<template>
  <div ref="myId" >

    <div v-for="(modelo, index) in dados" :key="index"   class="container_rows">
      <div>

        <div class="rows">
          <div class="inform informCliente">
            <div class="image" @click="showPopUp(modelo.img_path)">
              <img
                :src="`${this.$store.state.imgURL}${
                  modelo.img_path.split('.jpg' || '.png' || 'jpeg')[0]
                }.webp`"
              />
            </div>
            <!-- Controle de pop da imagem -->

            <div v-show="showPop" class="popUp pop" @click="closePopUp">
            <div class="image_popUp">
              <img v-if="path != ''" :src="`${this.$store.state.imgURL}${path}`" />
            </div>
          </div>
            <div class=" title"  @click="showAndCloseInform($event,modelo, filtro)">

                <h2>
                  {{ modelo.description_model }}
                  <i class="fas fa-chevron-right"></i>
                </h2>
                <p :class="filtro">{{ filtro }}</p>
              </div>
            <div class="number">
              <h1>{{ modelo._count }}</h1>
            </div>
          </div>
        </div>

        <!-- {{listarcpc(modelo)}} -->
        <!-- Começa aqui -->
        <div class="container_cliente">
          <div class="title_container">
            <h2>Embalagens anexadas:</h2>
          </div>
          <div id="scroll" class="scroll">
            
            <div
              class="rows rows-cliente"
              v-for="e in listEmbDisp.data"
              :key="e"
            >
            <div class="inform informCliente"
              
            >
              <div class="title title-cliente">
                <h2>{{ e.serial_number }}</h2>
              </div>
            </div>
            </div>
          </div>
        </div>
        <!-- <pagination :pageTotal="modelos.length" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../services/package/index";
import pagination from "../../Pagination.vue";
export default {
  components: { pagination },
  data: () => {
    return {
      showPop: false,
      path: "",
      teste: [{serial_number:"teste" }],
      listEmbDisp:{
        data:[]
      }

    };
  },
  props: {
    filtro: {
      type: String,
      required: true,
    },
    dados: {
      type: [Array, Object],
      required: true,
    },
  },
  methods: {
    async embalagens(model, count, filtro) {
      this.$store.commit("CHANGE_LOADING");  
      await http.packagesByModelOriginStatus(model, 0, filtro, 0, count).then((res) => {
        this.listEmbDisp.data = res.data
        this.$store.commit("CHANGE_LOADING");  
      })
      
    },
    async showAndCloseInform($event, modelo, filtro) {
      await this.embalagens(modelo.FK_modelo, modelo._count, filtro)

      const evento =
        $event.target.parentElement.parentElement.parentElement.parentElement
        .parentElement; 
      
        
      if (evento.classList.contains("showInf")) {
        evento.classList.remove("showInf");
        return;
      }
      
      const d = this.$refs.myId

      for(let i=0; i < d.children.length;i++){
          d.children[i].classList.remove("showInf");
      }
   
    
    

      if (evento.classList.contains("container_rows")) {

        evento.classList.add("showInf");
        return;
      }

    },
    showPopUp(modeloPath) {
      this.showPop = !this.showPop;

      this.path = modeloPath;

      let pop = document.querySelector(".pop");
      let image = document.querySelector(".pop").children[0];

      pop.classList.add("popUp");
      image.classList.add("image_popUp");
    },
    closePopUp($event) {
      let image = $event.target.parentNode;
      let popUp = $event.target.parentNode.parentNode;

      image.classList.remove("image_popUp");
      popUp.classList.remove("popUp");

      this.showPop = !this.showPop;
      this.path = "";
    },
  }

};
</script>

<style scoped>
.rows {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0.2rem;
  cursor: pointer;
}

.rows-cliente {
  cursor: default;
  border-bottom: 1px solid rgba(42, 42, 42, 0.103);
}

.container_rows {
  transition: 0.5s;
  border-bottom: 2px solid rgba(0, 0, 0, 0.116);
  height: 5rem;
  overflow: hidden;
}

.showInf {
  height: 22rem;
}

.showInf i {
  transform: rotateZ(90deg);
}

.inform {
  display: flex;
  width: 100%;
}

.image {
  width: 3rem;
  min-width: 3rem;
  min-height: 3rem;
  height: 3rem;
  background: var(--bgColor);
  border-radius: 50%;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.253);
  overflow: hidden;
}

.image_cliente {
  width: 6rem;
  min-width: 6rem;
  min-height: 3rem;
  height: 3rem;
  background: var(--bgColor);
  justify-content: center;
  display: flex;
  overflow: hidden;
}

.image_cliente img {
  width: 100%;
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
}

.title {
  margin-left: 1rem;
  display: grid;
  width: 100%;
  align-items: center;
}

.title h2 {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title p {
  color: var(--colorPrimary);
  font-weight: 700;
}

.title-cliente {
  color: var(--colorText-secondary);
}

.fas {
  color: var(--colorText-secondary);
  font-size: 1.2rem;
  transition: 0.2s;
}

.number h1 {
  color: var(--colorPrimary);
}

.number-cliente {
  opacity: 0.5;
}

.title_container h2 {
  color: var(--colorText-secondary);
  font-weight: 200;
  margin-top: 1rem;
}

.scroll {
  overflow-y: scroll;
  height: 14rem;
}

.Filial {
  color: var(--unityFilial) !important;
}

.CD {
  color: var(--unityCd) !important;
}

.Jaguarão {
  color: var(--unityJaguarao) !important;
}
</style>
